import { render, staticRenderFns } from "./PopupTotalMarkup.vue?vue&type=template&id=37306dee&scoped=true&"
import script from "./PopupTotalMarkup.vue?vue&type=script&lang=js&"
export * from "./PopupTotalMarkup.vue?vue&type=script&lang=js&"
import style0 from "./PopupTotalMarkup.vue?vue&type=style&index=0&id=37306dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37306dee",
  null
  
)

export default component.exports